
export const setupMetaData = (title, desc, imageUrl) => {
    if (title) {
        document.title = title;

        let titleTagElement = document.getElementsByTagName("title")[0];
        titleTagElement.innerText = title;

        let titleElement = document.getElementsByName("title")[0];
        titleElement.content = title;

        let twTitleElement = document.getElementsByName("twitter:title")[0];
        twTitleElement.content = title;
    }

    if (desc) {
        let descElement = document.getElementsByName("description")[0];
        descElement.content = desc;

        let twDescElement = document.getElementsByName("twitter:description")[0];
        twDescElement.content = desc;
    }

    if (imageUrl) {
        let twImageElement = document.getElementsByName("twitter:image")[0];
        twImageElement.content = imageUrl;
    }

    let metaElements = document.getElementsByTagName("meta");
    for (let i = 0; i < metaElements.length; ++i) {
        let element = metaElements[i];

        if (element.getAttribute("property")) {
            let property = element.getAttribute("property");
            if (title && property.toLowerCase() === "og:title") {
                element.content = title;
            } else if (desc && property.toLowerCase() === "og:description") {
                element.content = desc;
            } else if (property.toLowerCase() === "url" || property.toLowerCase() === "og:url") {
                element.content = window.location.href.replace(window.location.hash, "").replace(/\?.*/, "") + window.location.hash;
            } else if (imageUrl && (property.toLowerCase() === "og:image" || property.toLowerCase() === "og:image:secure_url")) {
                element.content = imageUrl;
            }
        }
    }

    let linkElements = document.getElementsByTagName("link");
    for (let i = 0; i < linkElements.length; ++i) {
        let element = linkElements[i];

        if (element.getAttribute("rel")) {
            let rel = element.getAttribute("rel");
            if (rel.toLowerCase() === "canonical") {
                element.href = window.location.href.replace(window.location.hash, "").replace(/\?.*/, "");
                break;
            }
        }
    }
};

export const setupBaseMetaData = () => {
    let title = "NBA ID | Benefits, Voting, Badges";
    let desc = "Enjoy the benefits and rewards of your NBA ID. Vote for your key players, favorite team moments, and earn badges while being rewarded for your NBA passion.";
    let imageUrl = "https://id.nba.com/memberhub_social_media_image_prod.png";

    setupMetaData(title, desc, imageUrl);
};

export const setupBadgeMetaData = badge => {
    if (badge) {
        let title = `NBA ID | Badges | ${badge.title}`;
        let desc = badge.description;
        let imageUrl = badge.image;

        setupMetaData(title, desc, imageUrl);
    }
};

export const setupChallengeMetaData = challenge => {
    if (challenge) {
        let title = `NBA ID | Challenge | ${challenge.title}`;
        let desc = challenge.description;
        let imageUrl = challenge.image;

        setupMetaData(title, desc, imageUrl);
    }
};